import React from 'react';
import { Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { Modal } from './comps';
import Button from '../form/Button';

const StyledModal = styled(Modal)`
  width: 566px;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

type SessionWarningReason = 'inactivity' | 'tokenFailure';

interface ISessionEndModalProps {
  onClose: () => void;
  minutesRemaining: number;
  expirationTime: string;
  reason: SessionWarningReason;
}

export const SessionEndModal: React.FC<ISessionEndModalProps> = ({
  onClose,
  minutesRemaining,
  expirationTime,
  reason,
}) => {
  const isInactivity = reason === 'inactivity';

  return (
    <StyledModal onRequestClose={onClose} isOpen center noCloseIcon>
      <div className="h-padding">
        <div className="content">
          <Poppins px={18} color="cflowerBlue">
            {isInactivity
              ? 'Due to inactivity, your session will expire in'
              : 'For security reasons, you will be logged out in'}
          </Poppins>
          <Spacer $px={4} />
          <Poppins px={18} color="cflowerBlue">
            <Poppins weight={500} px={18}>
              {minutesRemaining} {minutesRemaining === 1 ? 'minute' : 'minutes'}
            </Poppins>{' '}
            at{' '}
            <Poppins weight={500} px={18}>
              {expirationTime}
            </Poppins>
          </Poppins>
          <Spacer $px={40} />
          <Button primary onClick={onClose}>
            {isInactivity ? 'Continue Session' : 'OK'}
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};
